import React, { useState, useEffect } from 'react'
import { Button, Col, Row, Toggle } from 'rsuite'
import { startLoading, doneLoading } from '../../utils/loading'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import WaitingForReview from '../../widgets/waitingReview/WaitingForReview'

import FindBudgetYear from '../../widgets/findBudgetYear/FindBudgetYear'
import ProjectStatusPending from '../../widgets/projectStatus/ProjectStatusPending'
import ProjectStatusInProgress from '../../widgets/projectStatus/ProjectStatusInProgress'
import SearchSubProject from '../dashboard/SearchSubProject'
import Notification from '../dashboard/Notification'
import TableContractStatusWait from '../../widgets/tableContractStatusWait/TableContractStatusWait'

// widget
import Profile from '../../widgets/dashboard/Profile'
import ProjectCost from '../../widgets/dashboard/ProjectCost'
import ProposalProjectList from '../../widgets/projectList/ProposalProjectList'
import OngoingProjectList from '../../widgets/projectList/OngoingProjectList'
import AllProject from '../../widgets/dashboard/AllProject'
import WaitScrutinize from '../../widgets/dashboard/WaitScrutinize'
import WaitScreening from '../../widgets/dashboard/WaitScreening'
import ContractStatusWait from '../../widgets/dashboard/ContractStatusWait'
import WaitForReviewer from '../../widgets/dashboard/WaitForReviewer'
import ExpertWaitScrutinizeApproval from '../../widgets/dashboard/ExpertWaitScrutinizeApproval'
import ApprovalBudget from '../../widgets/dashboard/ApprovalBudget'
import MultiReviewGroup from '../review/projectList/MultiReviewGroup'

import ProjectChart1 from '../../widgets/dashboard/ProjectChart1'
import ProjectCusterDashboard from '../../widgets/dashboard/ProjectCusterDashboard'
import ProjectTableView from '../../widgets/dashboard/ProjectTableView'
import ProjectBudgetDisbursement from '../../widgets/dashboard/ProjectBudgetDisbursement'
import ProjectDashboard2 from '../../widgets/dashboard/ProjectDashboard2'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'

export default function DashboardSetting() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [showState, setShowState] = useState([])
  // const [startShowState, setStartShowState] = useState([])

  // let id = location.search.substring(1)

  useEffect(() => {
    handelGetSchemaDashboard()
  }, [])

  const handelGetSchemaDashboard = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = mockSchemaAll
      let showObjList = []
      for (let index = 0; index < response.forms.length; index++) {
        const item = response.forms[index]

        if (item.subForms?.length > 0) {
          showObjList.push(
            ...item.subForms.map((item) => {
              return { name: item.name, isShow: item.show }
            })
          )
        } else {
          showObjList.push({ name: item.name, isShow: item.show })
        }
      }

      // console.log('defaultRequest', defaultRequest)
      setShowState(showObjList)
      // setStartShowState(showObjList)
      setSchema(response)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = async () => {
    setIsLoading(true)
    startLoading()
    try {
      //call api
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const getUserDashboardId = () => {
    let id
    let code = localStorage.getItem('thp_user_code')
    if (code) {
      switch (code) {
        case 'THP-CallCenter':
        case 'THP-DeptAdmin':
        case 'THP-SystemAdmin':
          id = '0'
          break
        case 'THP-USER':
          id = '1'
          break
        case 'THP-Coordinator':
          id = '2'
          break
        case 'THP-Expert':
          id = '3'
          break
        case 'THP-Director':
          id = '5'
          break
        case 'THP-AsstDirector':
          id = '5'
          break
        case 'THP-Manager':
          id = '7'
          break
        case 'THP-AsstManager':
          id = '7'
          break
        case 'THP-ContractCenter':
          id = '8'
          break
        case 'THP-Legal':
          id += '10'
          break
        default:
          break
      }
    }

    return id
  }

  const onProjectCostSettingChange = (data, index) => {
    console.log('data', data, index)
  }

  const onProjectDashboard2SettingChange = (data, name) => {
    console.log('data', data, name)
  }

  const onNotificationSettingChange = (data) => {
    console.log('data', data)
  }

  const handleChange = (open, name) => {
    console.log('name : ', name, 'open : ', open)
    let data = showState

    let index = data.findIndex((item) => item.name == name)

    data[index].isShow = open

    setShowState(data)
  }

  // const renderRows = (rows, index, size, rsize) => {
  const RenderRows = ({ rows, index, size, rsize, showState }) => {
    const md_lg = size ? rsize : 24
    let form

    if (rows.subForms?.length > 0) {
      form = subForms(rows.subForms, showState)
    } else {
      switch (rows.name) {
        case 'profile':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <Profile />
            </Col>
          )
          break
        case 'projectCost':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProjectCost
                isSetting={true}
                isShow={rows.show}
                onSettingChange={onProjectCostSettingChange}
              />
            </Col>
          )
          break
        case 'statusProposalProject':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProposalProjectList
                isSetting={true}
                isShow={rows.show}
                // isShow={showState.find((item) => item.name == 'statusProposalProject')?.isShow}
                onSettingChange={handleChange}
                dashboradName="statusProposalProject"
              />
            </Col>
          )
          break
        case 'statusOngoingProject':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <OngoingProjectList
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="statusOngoingProject"
              />
            </Col>
          )
          break
        case 'allProject':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={4}>
              <AllProject
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="allProject"
              />
            </Col>
          )
          break
        case 'waitingForReview':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={5}>
              <WaitingForReview
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="waitingForReview"
              />
            </Col>
          )
          break
        case 'waitScrutinize':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={6}>
              <WaitScrutinize
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="waitScrutinize"
              />
            </Col>
          )
          break
        case 'waitScrutinizeMulti':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={6}>
              <MultiReviewGroup
                isNoSidebar
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="waitScrutinizeMulti"
              />
            </Col>
          )
          break
        case 'findBudgetYear':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={7}>
              <FindBudgetYear />
            </Col>
          )
          break
        case 'waitForReviewer':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={8}>
              <WaitForReviewer
                isNoSidebar
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="waitForReviewer"
              />
            </Col>
          )
          break
        case 'projectStatusPending':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={9}>
              <ProjectStatusPending
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="projectStatusPending"
              />
            </Col>
          )
          break

        case 'projectStatusInProgress':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProjectStatusInProgress
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="projectStatusInProgress"
              />
            </Col>
          )
          break
        case 'searchSubProject':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <SearchSubProject />
            </Col>
          )
          break
        case 'projectDashboard2':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProjectDashboard2
                isSetting={true}
                isShow={rows.show}
                onSettingChange={onProjectDashboard2SettingChange}
              />
            </Col>
          )
          break
        case 'notification':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <Notification
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="notification"
              />
            </Col>
          )
          break
        case 'contractStatusWait':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ContractStatusWait
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="contractStatusWait"
              />
            </Col>
          )
          break
        case 'waitScreening':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <WaitScreening
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="waitScreening"
              />
            </Col>
          )
          break
        case 'expertWaitScrutinizeApproval':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ExpertWaitScrutinizeApproval
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="expertWaitScrutinizeApproval"
              />
            </Col>
          )
          break
        // case 'subProject':
        //   form = (
        //     <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
        //       <SubProject />
        //     </Col>
        //   )
        //   break
        case 'approveProject':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ApprovalBudget
                enableMulti={false}
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="approveProject"
              />
            </Col>
          )
          break
        case 'approvalBudget':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ApprovalBudget
                enableMulti={true}
                isSetting={true}
                isShow={rows.show}
                onSettingChange={handleChange}
                dashboradName="approvalBudget"
              />
            </Col>
          )
          break
        case 'projectChart1':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProjectChart1
                isSetting={true}
                isShow={rows.show}
                onSettingChange={onProjectCostSettingChange}
              />
            </Col>
          )
          break
        case 'projectCusterDashboard':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProjectCusterDashboard
                isSetting={true}
                isShow={rows.show}
                onSettingChange={onProjectCostSettingChange}
              />
            </Col>
          )
          break
        case 'projectTableView':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProjectTableView
                isSetting={true}
                isShow={rows.show}
                onSettingChange={onProjectCostSettingChange}
              />
            </Col>
          )
          break
        case 'projectBudgetDisbursement':
          form = (
            <Col xs={24} sm={24} md={md_lg} lg={md_lg} key={index}>
              <ProjectBudgetDisbursement
                isSetting={true}
                isShow={rows.show}
                onSettingChange={onProjectCostSettingChange}
              />
            </Col>
          )
          break

        default:
          break
      }
    }

    return form
  }

  const subForms = (forms, showState) => {
    return forms?.map((item, index) => {
      // return renderRows(item, index, forms.length, item.md_lg)
      return (
        <RenderRows
          rows={item}
          index={index}
          size={forms.length}
          rsize={item.md_lg}
          showState={showState}
        />
      )
    })
  }

  if (error) {
    return <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
  }

  if (!schema || isLoading) {
    return <PanalLoadingTemplate />
  }

  return (
    <SidebarProposal>
      {/* <div className="custom-dashboard"> */}
      {/* <TopLevelNav />
        <PageToolbar /> */}
      <Row style={{ marginBottom: 80 }}>
        {schema.forms &&
          schema.forms.map((rows, index) => {
            return (
              <Row style={{ marginTop: 15 }} key={index}>
                {/* {renderRows(rows, index)} */}
                <RenderRows rows={rows} index={index} showState={showState} />
              </Row>
            )
          })}
        <div
          style={{
            zIndex: 101,
            right: 40,
            bottom: 30,
            position: 'fixed',
            // backgroundColor: 'whitesmoke',
            // textAlign: 'right',
          }}
        >
          <Button
            style={{ minWidth: 120, backgroundColor: '#2da888' }}
            appearance="primary"
            onClick={() => {
              onSubmit()
            }}
          >
            บันทึก
          </Button>
          <Button
            style={{ minWidth: 120, marginLeft: 20, backgroundColor: '#ed868c' }}
            appearance="primary"
            onClick={() => {
              handelGetSchemaDashboard()
            }}
          >
            ยกเลิก
          </Button>
        </div>
      </Row>
      {/* </div> */}
    </SidebarProposal>
  )
}

const mockSchemaAll = {
  forms: [
    {
      // profile ผู้ใช้งาน
      name: 'profile',
      subForms: [],
    },
    {
      // งบประมาณโครงการ
      name: 'projectCost',
      subForms: [],
      enable: {},
      show: false,
    },
    {
      // ผู้บริหาร กราฟที่1
      name: 'projectChart1',
      subForms: [],
      show: false,
    },
    {
      //ผู้บริหาร กราฟที่2
      name: 'projectCusterDashboard',
      subForms: [],
      show: false,
    },

    {
      //ผู้บริหาร ตาราง 1
      name: 'projectTableView',
      subForms: [],
      show: false,
    },
    {
      //ผู้บริหาร ตาราง 2
      name: 'projectBudgetDisbursement',
      subForms: [],
      show: false,
    },

    {
      //โครงการอยู่ระหว่าง ... 0 : โครงการอยู่ระหว่างนำเสนอ 1 : โครงการอยู่ระหว่างการดำเนินการ
      // name: 'projectStatusPanel',
      subForms: [
        {
          name: 'statusProposalProject',
          md_lg: 12,
          show: true,
        },
        {
          name: 'statusOngoingProject',
          md_lg: 12,
          show: false,
        },
      ],
    },
    {
      // dashborad นักวิชาการ
      // name: 'projectDashboard2',
      subForms: [
        {
          // dashborad นักวิชาการ
          name: 'projectDashboard2',
          md_lg: 18,
          show: true,
        },
        {
          name: 'notification',
          md_lg: 6,
          show: true,
        },
      ],
    },
    {
      //โครงการที่คัดกรอง
      name: 'waitScreening',
      subForms: [],
      show: true,
    },
    {
      //โครงการที่รอกลั่นกรอง
      name: 'waitScrutinize',
      subForms: [],
      show: true,
    },
    {
      //โครงการที่รอกลั่นกรอง หลายโครง
      name: 'waitScrutinizeMulti',
      subForms: [],
      show: true,
    },
    {
      // โครงการที่รอกลั่นกรองทางวิชาการ X
      name: 'waitForReviewer',
      subForms: [],
      show: true,
    },
    {
      // ข้อเสนอโครงการที่รอทำสัญญา/ข้อตกลง
      name: 'contractStatusWait',
      subForms: [],
      show: true,
    },
    {
      // โครงการรอดำเนินการ
      name: 'projectStatusPending',
      subForms: [],
    },
    {
      // โครงการทั้งหมด
      name: 'allProject',
      subForms: [],
      show: true,
    },
    {
      // โครงการที่รออนุมัติผู้ทรงคุณวุฒิสำหรับกลั่นกรองทางวิชาการ
      name: 'expertWaitScrutinizeApproval',
      subForms: [],
      show: true,
    },
    {
      // โครงการรอดำเนินการ
      name: 'projectStatusPending',
      subForms: [],
      show: true,
    },
    {
      // โครงการที่รออนุมัติ
      name: 'approveProject',
      subForms: [],
      show: true,
    },
    {
      // โครงการที่รออนุมัติทุน
      name: 'approvalBudget',
      subForms: [],
      show: true,
    },
  ],
}
